function isFetchError(error) {
  // We monkey patch native fetch to include useful data in case of request fail
  if (error.cppv3FetchErrorData) return true
}

function isLocalStorageError(error) {
  const PATTERNS = [
    'localStorage',
    'sessionStorage',
    'SecurityError',
    'operation is insecure',
    'getItem',
    'Failed to read'
  ]

  // Support both native JS errors and Bugsnag normalized format
  const msg = error?.message || error?.errorMessage || ''
  return PATTERNS.some(p => msg.includes(p))
}

export {
  isFetchError,
  isLocalStorageError,
}
